import React from 'react';
import './AiMatchPromoModal.css';
// Кнопка «Присоединиться» — того же алмазного цвета, что и кнопка битвы в
// меню; стиль подключаем и здесь, иначе на странице теста модалок его нет
import '../../MainMenu/AiMatchMenuButton/AiMatchMenuButton.css';
import MenuPromoModal from '../MenuPromoModal/MenuPromoModal';
import {AI_MATCH_TITLE, AI_PROMO_IMAGE_PATH} from '../../../configs/aiMatch';
import {splitTextByAccents} from '../../../utils/other/splitTextByAccents';
import {getAiPromoCountdown} from '../../../utils/aiMatch/getAiPromoStartLabel';
import {useSecondTick} from '../../../hooks/react/useSecondTick';
import {
  TEXT_AI_MATCH_PROMO,
  TEXT_AI_MATCH_PROMO_ACCENTS,
  TEXT_AI_MATCH_PROMO_JOIN,
  TEXT_AI_MATCH_WAITING_FIRST_PLAYER,
} from '../../../constants/text/aiMatch';

const PAGE_ID = 'AiMatchPromoModal';

/**
 * Приглашение в «Битву с AI Claude Opus» в главном меню. Корпус и звук —
 * общие для промо-модалок меню (MenuPromoModal), как у новости о рейтинговых
 * обличиях; подсветка и заголовок — цвета алмазной лиги, как кнопка события.
 *
 * Строка старта — тот же отсчет, что на кнопке меню и в самом лобби
 * (getAiPromoCountdown): «Сбор игроков 5 мин 0 сек» до 21:00, «Старт через
 * 7 мин 5 сек», когда сервер взвел отсчет, или «Ждем первого игрока». Тикает
 * раз в секунду по часам сервера.
 *
 * Кому и когда показывать, решает меню (см. checkIfAiMatchPromoOpenable): пока
 * лобби дня ждет игроков, не чаще раза за игровой день и ниже всех остальных
 * модалок меню. Обе кнопки ведут в onClose — там меню ставит отметку показа;
 * «Присоединиться» вдобавок входит в лобби (гостю — модалка входа). Сама
 * модалка на сервер не ходит: ее же открывает превью в админке
 * (AdminModalsTestPage)
 *
 * @param {Object|null} aiPromo - лобби дня (normalizeAiPromo; в превью
 *   админки — собранное там же)
 * @param {number} [serverTimeDelta] - поправка часов: время сервера = Date.now() + она
 * @param {Function} onJoin
 * @param {Function} onClose
 */
const AiMatchPromoModal = ({aiPromo, serverTimeDelta = 0, onJoin, onClose}) => {
  const countdown = getAiPromoCountdown(aiPromo, {now: Date.now() + serverTimeDelta});
  // Часы тикают, только пока есть отсчет
  useSecondTick(countdown != null);

  return (
    <MenuPromoModal
      pageId={PAGE_ID}
      title={AI_MATCH_TITLE}
      imagePath={AI_PROMO_IMAGE_PATH}
      imageAlt={AI_MATCH_TITLE}
      modalClassName={'ai-match-promo-modal'}
      titleClassName={'text-diamond'}
      action={{
        buttonId: 'join',
        label: TEXT_AI_MATCH_PROMO_JOIN,
        className: 'main-menu-button_ai-match main-menu-button_ai-match-promo-modal',
        onClick: onJoin,
      }}
      onClose={onClose}
    >
      <p className={'menu-promo-modal_text'}>
        {splitTextByAccents(TEXT_AI_MATCH_PROMO, TEXT_AI_MATCH_PROMO_ACCENTS).map((part, index) => (
          part.isAccent
            ? <span key={index} className={'text-diamond'}>{part.text}</span>
            : <React.Fragment key={index}>{part.text}</React.Fragment>
        ))}
      </p>
      <p className={'menu-promo-modal_text ai-match-promo-modal_start'}>
        {countdown ? (
          <>
            {countdown.prefix} <span className={'text-diamond'}>{countdown.timeText}</span>
          </>
        ) : TEXT_AI_MATCH_WAITING_FIRST_PLAYER}
      </p>
    </MenuPromoModal>
  );
};

export default AiMatchPromoModal;
